import NodeMessaging from "messaging/NodeMessaging.js";
import CustomZObject from './CustomZObject.js';

export default class ZColor extends CustomZObject {
    constructor(zobject) {
        super(zobject);
        this._color = "#000000";
        this.newOutlet("color");
    }

    get color() {
        return this._color;
    }

    set color(c) {
        this._color = c;
        console.log('sending message out', c);
        this.sendMessage("color", c);
    }

    getJson() {
        return {
            ... super.getJson(),
            color: this.color
        };
    }

    fromJson(json, isCopy) {
        super.fromJson(json, isCopy);
        this.color = json.color;
    }
}

